import axios from "axios";
import { useEffect, useState } from "react";
import { config } from "../../data/config";
import { getCookies } from "cookies-next";
import { Button, Input, TagInput } from "rsuite";
import { useParams } from "react-router-dom";
import ImageUploader from '../tools/uploaderImage';
import ChunkedFileUpload from "../tools/chunkupload";

export default function EditStory() {
    let { Id } = useParams();

    let cookie = getCookies();
    const [data, setData] = useState<any>(null);

    const load = async () => {
        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/story/' + Id,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });


            setData(res.data.message);
        } catch (error: any) {

        }
    }

    const save = async () => {
        try {
            let res = await axios({
                method: 'put',
                url: config.url + '/v1/dashboard/story/' + Id,
                data: data,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });


            setData(res.data.message);
        } catch (error: any) {

        }
    }

    const styles = { width: '100%', display: 'block' };

    useEffect(() => {
        load();

    }, []);
    return (
        <div>
            <div className={`container m-auto`}>
                <Button href="/dashboard/Feature/Story">بازگشت</Button>
                <div className="w-[400px] m-auto">
                    {
                        data != null && <form className=" flex flex-col gap-2">
                            <div className="text-right ">نام</div>
                            <Input
                                defaultValue={data.name}
                                onChange={(e) => setData({ ...data, name: e })}
                            ></Input>
                            <div className="text-right">نام کاربری</div>
                            <Input defaultValue={data.username}
                                onChange={(e) => setData({ ...data, username: e })}
                            ></Input>
                            <div className="text-right">نوشته </div>
                            <Input defaultValue={data.text}
                                onChange={(e) => setData({ ...data, text: e })}

                            ></Input>
                            <div className="text-right">تگ ها </div>
                            <TagInput
                                defaultValue={data.tags}
                                onChange={(e) => setData({ ...data, tags: e })}
                                placeholder="TAGS" style={styles} />
                            <div className="text-right">آواتار </div>



                            <div className="text-right">ویدیو </div>
                            <Button onClick={() => { save(); }} className="mt-4">ذخیره سازی</Button>

                        </form>
                    }

                    {
                        data != null && <ImageUploader key={12} id={data.id} component={'story'}></ImageUploader>
                    }

                 {
                     data != null &&    <ChunkedFileUpload key={2} id={data._id} component={'storyvideo'} ></ChunkedFileUpload>
                 } 


                </div>

            </div>
        </div>
    )
}